// Main CashierMutations

export const updateCashiersList = (state, payload) => {
  state.cashiersList = payload
}

export const fetchCashierInfo = (state, payload) => {
  state.cashierInfo = payload
}
